import { CustomNode } from '../../../types';
import { removeContactIcon } from '../../../icons';

const DEFAULT_ICON = removeContactIcon;

export const removeContactConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
